export default{
    "GET_PROFILE": "GET_PROFILE",
    "GET_PROFILE_FULFILLED" : "GET_PROFILE_FULFILLED",
    "GET_PROFILE_PENDING" : "GET_PROFILE_PENDING",
    "GET_PROFILE_REJECTED": "GET_PROFILE_REJECTED",
    "SAVE_PROFILE_FUFILLED" : "SAVE_PROFILE_FUFILLED",
    "SAVE_PROFILE_REJECTED" : "SAVE_PROFILE_REJECTED",
    "SAVE_PROFILE" : "SAVE_PROFILE",
    "SAVE_PROFILE_PENDING" : "SAVE_PROFILE_PENDING",
    "UPDATE_PROFILE" : "UPDATE_PROFILE",
    "UPDATE_SAVING": "UPDATE_SAVING",
    "UPDATE_EDITING": "UPDATE_EDITING",
    "GET_ACHIEVEMENTS_PENDING": "GET_ACHIEVEMENTS_PENDING",
    "GET_ACHIEVEMENTS_FULFILLED": "GET_ACHIEVEMENTS_FULFILLED",
    "UPDATE_ERRORS": "UPDATE_ERRORS",
    "GET_QUESTIONS": "GET_QUESTIONS",
    "GET_QUESTIONS_FULFILLED": "GET_QUESTIONS_FULFILLED",
    "UPDATE_USER_QUESTION_ANSWERS": "UPDATE_USER_QUESTION_ANSWERS",
    "TOGGLE_INTEREST": "TOGGLE_INTEREST"
}